import { render } from "./UserProfilePosts.vue?vue&type=template&id=0eb003bf&scoped=true"
import script from "./UserProfilePosts.vue?vue&type=script&lang=js"
export * from "./UserProfilePosts.vue?vue&type=script&lang=js"

import "./UserProfilePosts.vue?vue&type=style&index=0&id=0eb003bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0eb003bf"]])

export default __exports__